export default __webpack_public_path__ + "static/media/female_01.b6fe98a3.png";